export default {
  article: {
    breadcrumb: {
      home: "Accueil",
    },
    author: "Équipe éditoriale",
    updated: "Dernière mise à jour",
    cta: {
      title: "Commencez à explorer le spreadsheet",
      text: "Prêt à parcourir ? Retournez à l'accueil pour choisir une catégorie, ou visitez le site principal pour continuer vos achats.",
      primary: "Parcourir les catégories",
      secondary: "Visiter le site principal",
    },
    related: {
      title: "Ressources associées",
      homeCard: "Hub AllChinaBuy Spreadsheet",
      homeDesc: "Parcourez toutes les catégories, guides et ressources au même endroit.",
    },
    tipsTitle: "Conseils clés",
    faqTitle: "Questions fréquentes",
    disclaimer:
      "Ceci est un site d'information indépendant et n'est ni affilié ni approuvé par AllChinaBuy sauf mention explicite. Les informations peuvent changer ; les utilisateurs doivent vérifier les conditions, prix, conditions d'expédition et politiques actuelles avant de décider.",
    notFound: {
      title: "Guide introuvable",
      text: "Nous n'avons pas trouvé le guide que vous cherchiez.",
      back: "Retour à l'accueil",
    },
    content: {
      "allchinabuy-spreadsheet": {
        title: "AllChinaBuy Spreadsheet : le guide complet",
        subtitle:
          "Un guide pratique et original pour comprendre et utiliser un AllChinaBuy spreadsheet — de sa définition aux astuces qui vous aident à trouver de meilleurs produits plus vite.",
        metaTitle: "AllChinaBuy Spreadsheet : le guide complet pour mieux trouver",
        metaDescription:
          "Découvrez ce qu'est un AllChinaBuy spreadsheet, comment l'utiliser, quelles catégories explorer et les astuces pour trouver de meilleurs produits plus vite.",
        metaKeywords:
          "AllChinaBuy spreadsheet, AllChinaBuy trouvailles, guide AllChinaBuy, guide d'achat AllChinaBuy",
        tag: "Guide complet",
        readTime: "6 min de lecture",
        intro: [
          "Si vous avez déjà parcouru des produits à expédier à l'international, vous avez probablement rencontré l'idée d'un AllChinaBuy spreadsheet. En bref, c'est une façon d'organiser la recherche — en rassemblant liens produits, catégories, notes de vendeur et détails de contrôle qualité dans un seul endroit lisible.",
          "Ce guide explique ce qu'est un AllChinaBuy spreadsheet, pourquoi les acheteurs l'utilisent, comment commencer et les astuces qui rendent le processus plus fluide. Que vous soyez débutant ou habitué, l'objectif reste le même : trouver ce que vous voulez avec moins de défilement et plus de confiance.",
        ],
        sections: [
          {
            h: "Qu'est-ce qu'un AllChinaBuy spreadsheet ?",
            p: [
              "Un AllChinaBuy spreadsheet est essentiellement une liste organisée. Il regroupe les produits par catégorie — chaussures, hoodies, t-shirts, sacs et plus — et associe à chaque entrée des informations utiles, comme un lien produit, une courte description, des notes de vendeur et l'état du contrôle qualité.",
              "Imaginez un tableau de recherche personnel. Au lieu de garder des dizaines d'onglets ouverts, vous conservez les liens et notes importants dans une vue structurée. Cette structure est ce qui le rend utile : vous pouvez parcourir, comparer et retrouver des articles sans perdre le fil.",
            ],
          },
          {
            h: "Pourquoi les acheteurs utilisent un spreadsheet",
            p: [
              "La raison principale est la clarté. Parcourir un grand catalogue devient vite écrasant, surtout quand on compare des articles similaires. Un spreadsheet réduit ce bruit en ne montrant que les éléments qui comptent.",
              "La seconde raison est la rapidité. Quand vos trouvailles sont déjà organisées, passer d'une paire de baskets à un hoodie puis à un sac ne prend qu'un clic. Enfin, un spreadsheet vous aide à garder une trace — votre liste vous attend si vous commandez plus tard.",
            ],
          },
          {
            h: "Comment utiliser un AllChinaBuy spreadsheet",
            p: [
              "Commencez par choisir une catégorie — chaussures, hoodies, t-shirts, vestes ou tout autre groupe disponible. Chaque catégorie mène directement à une sélection correspondante sur le site principal.",
              "Parcourez ensuite les articles et notez ceux qui ressortent. Prêtez attention aux infos de contrôle qualité ou aux avis, car c'est souvent ce qui distingue une bonne trouvaille d'une déception.",
              "Enfin, ouvrez le site principal et finalisez votre achat. Aucun outil spécial n'est nécessaire — juste un peu d'organisation et les liens déjà rassemblés.",
            ],
          },
          {
            h: "Catégories populaires à explorer",
            p: [
              "Le AllChinaBuy spreadsheet couvre un large éventail de vêtements et accessoires : chaussures, hoodies et sweats, t-shirts, vestes, pantalons et shorts, couvre-chefs, ensembles, sous-vêtements, maillots, accessoires, sacs, ceintures et parfums, plus une catégorie « autres ».",
              "Chaque catégorie de ce site renvoie à la sélection correspondante sur le site principal, pour passer directement de l'aperçu au catalogue complet.",
            ],
          },
        ],
        tips: [
          {
            t: "Commencez par une catégorie",
            d: "Concentrez-vous sur une catégorie à la fois pour comparer des articles similaires sans vous perdre.",
          },
          {
            t: "Vérifiez les notes QC et avis",
            d: "Lisez les informations de contrôle qualité ou d'avis avant de décider.",
          },
          {
            t: "Gardez une liste courte",
            d: "Notez vos articles préférés, puis revoyez votre liste avant de commander.",
          },
          {
            t: "Vérifiez frais et prix",
            d: "Les coûts changent, confirmez les détails actuels sur le site principal.",
          },
          {
            t: "Évaluez les vendeurs vous-même",
            d: "Utilisez les infos vendeur comme point de départ et faites vos propres recherches.",
          },
        ],
        faq: [
          {
            q: "Le AllChinaBuy spreadsheet est-il gratuit ?",
            a: "Ce site est une ressource d'information indépendante et les liens sont libres à parcourir. Les achats se font sur le site principal.",
          },
          {
            q: "Faut-il un compte pour utiliser le spreadsheet ?",
            a: "Non, aucun compte n'est requis pour parcourir les catégories et guides de ce site.",
          },
          {
            q: "Les liens sont-ils à jour ?",
            a: "Les liens renvoient aux pages du site principal, qui restent la source la plus actuelle.",
          },
          {
            q: "Est-ce le site officiel AllChinaBuy ?",
            a: "Non. Ceci est une ressource indépendante, non affiliée ni approuvée par AllChinaBuy.",
          },
        ],
      },
      "allchinabuy-finds": {
        title: "AllChinaBuy Finds : trouver de meilleurs produits plus vite",
        subtitle:
          "Une méthode simple et reproductible pour dénicher des trouvailles AllChinaBuy intéressantes dans chaque catégorie, sans défilement interminable.",
        metaTitle: "AllChinaBuy Finds : trouver de meilleurs produits plus vite",
        metaDescription:
          "Découvrez une méthode simple pour trouver de meilleurs produits AllChinaBuy. Apprenez à repérer les bonnes trouvailles, à utiliser le QC et à bâtir une liste courte.",
        metaKeywords:
          "AllChinaBuy trouvailles, trouvailles produits AllChinaBuy, meilleures trouvailles AllChinaBuy",
        tag: "Guide des trouvailles",
        readTime: "5 min de lecture",
        intro: [
          "Trouver de bons produits sur une grande plateforme peut ressembler à chercher une aiguille dans une botte de foin. L'astuce n'est pas de voir plus d'articles — c'est de regarder les bons articles de façon structurée.",
          "Ce court guide présente une méthode reproductible pour faire ressortir des trouvailles AllChinaBuy intéressantes, du choix d'une catégorie à la constitution d'une liste fiable.",
        ],
        sections: [
          {
            h: "Commencez avec une intention claire",
            p: [
              "Avant de parcourir, décidez ce que vous cherchez vraiment. Un objectif vague mène à une navigation dispersée, tandis qu'un objectif précis rétrécit immédiatement votre champ.",
            ],
          },
          {
            h: "Utilisez les catégories pour affiner",
            p: [
              "Les catégories sont votre meilleur raccourci. Plutôt qu'un mot-clé unique, sautez dans une catégorie comme chaussures, sacs ou accessoires pour parcourir une sélection déjà pertinente.",
            ],
          },
          {
            h: "Filtrez avec le QC et les notes",
            p: [
              "La différence entre une trouvaille moyenne et excellente, c'est le détail. Cherchez des articles avec photos de contrôle qualité ou notes de vendeur claires, et évitez ce qui reste vague.",
            ],
          },
        ],
        tips: [
          {
            t: "Une catégorie à la fois",
            d: "Rester dans une catégorie rend vos comparaisons plus pertinentes.",
          },
          {
            t: "Préférez les fiches détaillées",
            d: "Plus de détails maintenant, moins de surprises après la commande.",
          },
          {
            t: "Sauvegardez puis revoyez",
            d: "Collectez d'abord des candidats, puis réduisez votre liste avant de commander.",
          },
        ],
        faq: [
          {
            q: "Comment trouver les meilleures trouvailles AllChinaBuy ?",
            a: "Partez d'un objectif clair, parcourez une catégorie précise et privilégiez les fiches avec photos QC et notes détaillées.",
          },
          {
            q: "Les trouvailles de ce site sont-elles organisées ?",
            a: "Les catégories renvoient aux sélections du site principal, la source la plus actuelle.",
          },
          {
            q: "À quelle fréquence vérifier les nouveautés ?",
            a: "Régulièrement, car la disponibilité et le stock changent sur le site principal.",
          },
        ],
      },
      "allchinabuy-review": {
        title: "Avis AllChinaBuy : fonctionnalités, avantages et limites",
        subtitle:
          "Un aperçu honnête et pratique de ce qu'une plateforme comme AllChinaBuy propose — ses forces, ses limites et ce qu'il faut vérifier avant de commander.",
        metaTitle: "Avis AllChinaBuy : fonctionnalités, avantages et limites",
        metaDescription:
          "Un avis AllChinaBuy pratique couvrant les fonctionnalités, avantages, limites et points à vérifier avant de commander. Indépendant et équilibré.",
        metaKeywords:
          "avis AllChinaBuy, avis plateforme AllChinaBuy, AllChinaBuy honnête",
        tag: "Avis",
        readTime: "7 min de lecture",
        intro: [
          "Avant d'utiliser un service d'achat, il est utile de comprendre ce qu'il fait réellement — et ce qu'il ne fait pas. Cet avis passe en revue les fonctionnalités typiques d'une plateforme comme AllChinaBuy en termes simples.",
          "Nous restons volontairement équilibrés. Un bon avis n'est pas du battage ; il vous aide à voir clairement les avantages et les limites avant de vous engager.",
        ],
        sections: [
          {
            h: "À quoi sert AllChinaBuy",
            p: [
              "AllChinaBuy est une plateforme d'achat qui aide à parcourir des produits, gérer des achats et organiser l'expédition internationale. Sa valeur principale est la commodité — réunir découverte, achat et expédition en un seul endroit.",
            ],
          },
          {
            h: "Les avantages",
            p: [
              "Les principaux atouts sont l'organisation et le choix. Les catégories aident à parcourir vite, les options de contrôle qualité ajoutent de la confiance, et un large catalogue offre beaucoup de possibilités.",
            ],
          },
          {
            h: "Les limites à garder en tête",
            p: [
              "Aucune plateforme n'élimine tout risque. Les frais d'expédition varient, la qualité dépend des vendeurs, et les politiques changent. La plateforme est un outil — les résultats dépendent de votre propre vigilance.",
            ],
          },
        ],
        tips: [
          {
            t: "Traitez les avis comme un point de départ",
            d: "Comprenez les bases, puis vérifiez les détails vous-même.",
          },
          {
            t: "Vérifiez les politiques avant",
            d: "Les conditions d'expédition et de remboursement changent.",
          },
          {
            t: "Comparez avant de vous engager",
            d: "Utilisez les catégories et le QC pour comparer.",
          },
        ],
        faq: [
          {
            q: "AllChinaBuy est-il une bonne plateforme ?",
            a: "Elle offre une organisation et un choix utiles, mais les résultats dépendent de votre vigilance.",
          },
          {
            q: "Quelles sont les principales fonctionnalités ?",
            a: "Parcours par catégorie, achat, contrôle qualité et expédition internationale.",
          },
          {
            q: "Y a-t-il des inconvénients ?",
            a: "Les frais varient, la qualité dépend des vendeurs, et les politiques évoluent.",
          },
        ],
      },
      "allchinabuy-shipping-cost": {
        title: "Coût d'expédition AllChinaBuy : méthodes, estimations et astuces",
        subtitle:
          "Comprenez ce qui influence le coût d'expédition AllChinaBuy et comment l'estimer, pour éviter les surprises à la caisse.",
        metaTitle: "Coût d'expédition AllChinaBuy : méthodes, estimations et astuces",
        metaDescription:
          "Un guide clair sur le coût d'expédition AllChinaBuy. Découvrez ce qui influence le prix, les méthodes courantes et des astuces pour estimer votre total.",
        metaKeywords:
          "coût expédition AllChinaBuy, prix expédition AllChinaBuy, estimation expédition AllChinaBuy",
        tag: "Guide expédition",
        readTime: "6 min de lecture",
        intro: [
          "L'expédition est souvent la partie d'une commande internationale qui surprend. La bonne nouvelle, c'est que le coût n'est pas un mystère — il dépend de quelques facteurs que vous pouvez comprendre en quelques minutes.",
          "Ce guide explique ce qui influence le coût d'expédition AllChinaBuy, les méthodes courantes et des moyens simples d'estimer votre total avant de vous engager.",
        ],
        sections: [
          {
            h: "Ce qui influence le coût",
            p: [
              "Trois choses comptent le plus : le pays de destination, le poids et les dimensions du colis, et la méthode choisie. Les lignes rapides et les colis lourds coûtent plus cher, les lignes économiques réduisent le prix.",
            ],
          },
          {
            h: "Les méthodes d'expédition courantes",
            p: [
              "La plupart des plateformes offrent des lignes économiques aux services express. Les lignes économiques sont moins chères mais lentes, les express arrivent plus vite à un prix plus élevé.",
            ],
          },
          {
            h: "Comment estimer votre total",
            p: [
              "Le plus fiable est de vérifier les tarifs actuels sur le site principal pour vos articles et votre destination. En général, les articles lourds et les destinations lointaines augmentent le coût.",
            ],
          },
        ],
        tips: [
          {
            t: "Vérifiez les tarifs pour votre destination",
            d: "Les tarifs varient beaucoup, confirmez toujours pour votre pays.",
          },
          {
            t: "Regroupez si possible",
            d: "Combiner les articles en un seul envoi peut être moins cher.",
          },
          {
            t: "Adaptez la vitesse à l'urgence",
            d: "Choisissez l'économie pour la patience, l'express seulement si besoin.",
          },
        ],
        faq: [
          {
            q: "Combien coûte l'expédition AllChinaBuy ?",
            a: "Cela dépend de la destination, du poids et de la méthode ; vérifiez les tarifs actuels sur le site principal.",
          },
          {
            q: "L'expédition économique est-elle fiable ?",
            a: "Généralement fiable mais plus lente ; examinez les options et le suivi avant de choisir.",
          },
          {
            q: "Puis-je réduire mes frais ?",
            a: "Regrouper les articles et choisir des lignes plus lentes sont deux moyens courants.",
          },
        ],
      },
      "allchinabuy-coupon": {
        title: "Coupon et code promo AllChinaBuy : où trouver les offres",
        subtitle:
          "Un regard réaliste sur le fonctionnement des coupons et codes promo AllChinaBuy, où les chercher et comment éviter de courir après des offres inexistantes.",
        metaTitle: "Coupon et code promo AllChinaBuy : où trouver les offres",
        metaDescription:
          "Découvrez comment fonctionnent les coupons et codes promo AllChinaBuy, où trouver les offres actuelles et comment les utiliser sans tomber sur de fausses promos.",
        metaKeywords:
          "coupon AllChinaBuy, code promo AllChinaBuy, code réduction AllChinaBuy, offres AllChinaBuy",
        tag: "Guide coupons",
        readTime: "4 min de lecture",
        intro: [
          "Tout le monde aime une remise, mais les coupons sur une plateforme d'achat fonctionnent différemment d'un site de vente classique. Les promotions vont et viennent, et la meilleure source est presque toujours la plateforme elle-même.",
          "Ce guide explique comment les coupons et codes promo AllChinaBuy fonctionnent, où chercher et comment les utiliser avec bon sens.",
        ],
        sections: [
          {
            h: "Comment fonctionnent les coupons",
            p: [
              "Les promotions prennent quelques formes : remises à l'échelle du site, offres par catégorie, ou codes occasionnels partagés aux acheteurs. Elles sont limitées dans le temps et changent souvent.",
            ],
          },
          {
            h: "Où trouver les offres actuelles",
            p: [
              "L'endroit le plus fiable est le site principal, où les promotions actives sont affichées. Les liens de catégories de ce site sont un bon point de départ.",
            ],
          },
          {
            h: "Éviter les fausses offres",
            p: [
              "Méfiez-vous des sites tiers qui promettent des économies garanties. Les offres changent vite, et un code expiré reste un code expiré. Confirmez toujours qu'une promo est active.",
            ],
          },
        ],
        tips: [
          {
            t: "Vérifiez d'abord le site principal",
            d: "Les promotions actives sont affichées là où vous achetez.",
          },
          {
            t: "Cherchez les offres par catégorie",
            d: "Certaines remises ne s'appliquent qu'à certains groupes.",
          },
          {
            t: "Ne bâtissez pas un plan sur un coupon",
            d: "Traitez les remises comme un bonus, pas une garantie.",
          },
        ],
        faq: [
          {
            q: "AllChinaBuy a-t-il des coupons ?",
            a: "Les promotions changent, vérifiez le site principal pour les offres actuelles.",
          },
          {
            q: "Où trouver les codes promo AllChinaBuy ?",
            a: "Le site principal est la source la plus fiable.",
          },
          {
            q: "Les sites de coupons tiers sont-ils fiables ?",
            a: "Soyez prudent, les offres changent vite et les codes expirés sont fréquents.",
          },
        ],
      },
      "allchinabuy-warehouse": {
        title: "Entrepôt AllChinaBuy : stockage, QC et commandes",
        subtitle:
          "Une explication claire de l'utilité de l'entrepôt AllChinaBuy et de la façon dont stockage, contrôles qualité et préparation s'articulent.",
        metaTitle: "Entrepôt AllChinaBuy : stockage, QC et commandes",
        metaDescription:
          "Découvrez comment fonctionne l'entrepôt AllChinaBuy — réception, stockage, contrôle qualité et préparation à l'expédition internationale. Un guide simple et pratique.",
        metaKeywords:
          "entrepôt AllChinaBuy, guide entrepôt AllChinaBuy, processus entrepôt AllChinaBuy",
        tag: "Guide entrepôt",
        readTime: "6 min de lecture",
        intro: [
          "L'entrepôt est l'étape intermédiaire discrète d'une commande internationale. Après l'achat, un article passe généralement par un entrepôt où il est reçu, stocké, contrôlé puis emballé pour l'expédition.",
          "Ce guide explique ce que fait l'entrepôt AllChinaBuy et comment le stockage et le contrôle qualité s'intègrent à votre commande.",
        ],
        sections: [
          {
            h: "Le rôle de l'entrepôt",
            p: [
              "L'entrepôt sert de point de regroupement central. Les articles des vendeurs y arrivent d'abord, puis sont enregistrés, stockés et combinés avec vos autres achats en un seul colis pour l'expédition.",
            ],
          },
          {
            h: "Comment fonctionne le stockage",
            p: [
              "Les articles sont conservés pendant une fenêtre de stockage définie, ce qui vous laisse le temps d'accumuler plusieurs commandes et de les expédier ensemble. Combiner est souvent plus économique.",
            ],
          },
          {
            h: "Où intervient le QC",
            p: [
              "L'entrepôt est aussi l'endroit où se font les contrôles qualité. Vous pouvez demander des photos d'inspection avant l'expédition pour confirmer la qualité et détecter les problèmes à temps.",
            ],
          },
        ],
        tips: [
          {
            t: "Comprenez la fenêtre de stockage",
            d: "Sachez combien de temps les articles sont gardés pour planifier le regroupement.",
          },
          {
            t: "Utilisez les photos QC avant l'envoi",
            d: "Demandez des photos pour détecter les problèmes tôt.",
          },
          {
            t: "Combinez quand c'est pertinent",
            d: "Expédier plusieurs articles ensemble est souvent moins cher.",
          },
        ],
        faq: [
          {
            q: "Qu'est-ce que l'entrepôt AllChinaBuy ?",
            a: "C'est là que les articles sont reçus, stockés, contrôlés et préparés pour l'expédition internationale.",
          },
          {
            q: "Combien de temps les articles sont-ils stockés ?",
            a: "Les fenêtres varient, vérifiez la politique actuelle sur le site principal.",
          },
          {
            q: "Le QC a-t-il lieu à l'entrepôt ?",
            a: "Oui, les photos de contrôle sont généralement prises à l'entrepôt avant l'envoi.",
          },
        ],
      },
      "allchinabuy-legit": {
        title: "AllChinaBuy est-il légitime ? Un guide pratique",
        subtitle:
          "Un regard posé et équilibré sur ce que signifie la légitimité d'une plateforme d'achat, et comment évaluer AllChinaBuy par vous-même.",
        metaTitle: "AllChinaBuy est-il légitime ? Un guide pratique",
        metaDescription:
          "AllChinaBuy est-il légitime ? Un guide pratique et équilibré pour évaluer la plateforme — vendeurs, produits, paiements et expédition.",
        metaKeywords:
          "AllChinaBuy légitime, AllChinaBuy fiable, AllChinaBuy sûr à utiliser",
        tag: "Guide de légitimité",
        readTime: "7 min de lecture",
        intro: [
          "« Cette plateforme est-elle légitime ? » est une question légitime avant de dépenser. La réponse honnête est que la légitimité n'est pas un simple oui ou non — elle dépend de votre usage et de votre vigilance.",
          "Ce guide passe en revue ce qu'il faut examiner pour décider si AllChinaBuy vous convient, sans exagérer dans un sens ni dans l'autre.",
        ],
        sections: [
          {
            h: "Ce que « légitime » signifie vraiment",
            p: [
              "Une plateforme légitime offre un service réel et fonctionnel avec des processus transparents. Cela diffère d'une garantie que chaque produit ou vendeur est parfait. Comprendre cette distinction est la première étape.",
            ],
          },
          {
            h: "Ce qu'il faut évaluer vous-même",
            p: [
              "Les contrôles les plus importants sont les vôtres : examinez les infos vendeur, cherchez les photos QC, comprenez les options d'expédition et lisez les politiques de paiement et de remboursement.",
            ],
          },
          {
            h: "Les signes d'une approche prudente",
            p: [
              "Les acheteurs qui prennent leur temps, comparent et vérifient avant de commander vivent des expériences plus fluides. Il n'y a pas de raccourci — la protection passe par la diligence.",
            ],
          },
        ],
        tips: [
          {
            t: "Vérifiez avant de faire confiance",
            d: "Vérifiez vous-même les infos vendeur et les politiques.",
          },
          {
            t: "Cherchez les photos QC",
            d: "Les photos de contrôle sont un bon signe de confirmation.",
          },
          {
            t: "Commencez petit",
            d: "Une première commande modeste est un moyen peu risqué d'apprendre.",
          },
        ],
        faq: [
          {
            q: "AllChinaBuy est-il légitime ?",
            a: "C'est une plateforme d'achat, mais évaluez toujours produits, vendeurs, paiements et expédition vous-même.",
          },
          {
            q: "Comment vérifier la fiabilité d'un vendeur ?",
            a: "Examinez les infos vendeur, cherchez les photos QC et lisez les politiques actuelles.",
          },
          {
            q: "Quelle est la façon la plus sûre de commencer ?",
            a: "Commencez par une petite commande et vérifiez chaque étape.",
          },
        ],
      },
      "allchinabuy-qc": {
        title: "Guide QC AllChinaBuy : vérifier la qualité des produits",
        subtitle:
          "Apprenez comment fonctionne le contrôle qualité sur une plateforme d'achat et comment utiliser les photos QC pour confirmer ce que vous recevez.",
        metaTitle: "Guide QC AllChinaBuy : vérifier la qualité des produits",
        metaDescription:
          "Un guide QC AllChinaBuy pratique. Apprenez comment fonctionnent les contrôles, comment demander et lire les photos QC et détecter les problèmes avant l'envoi.",
        metaKeywords:
          "QC AllChinaBuy, photos QC AllChinaBuy, contrôle qualité AllChinaBuy",
        tag: "Guide QC",
        readTime: "5 min de lecture",
        intro: [
          "Le contrôle qualité, ou QC, est l'une des fonctions les plus utiles d'une plateforme d'achat — et l'une des plus sous-utilisées. Il vous permet de voir votre article avant l'envoi, pour détecter les problèmes tant qu'ils sont faciles à corriger.",
          "Ce guide explique comment le QC AllChinaBuy fonctionne et comment tirer le meilleur parti des photos d'inspection.",
        ],
        sections: [
          {
            h: "Ce qu'est réellement le QC",
            p: [
              "Le QC est une vérification effectuée avant l'expédition, généralement en photographiant votre article à l'entrepôt. Le but est de confirmer que l'article correspond à votre commande et de révéler les défauts évidents.",
            ],
          },
          {
            h: "Comment demander des photos QC",
            p: [
              "Vous pouvez demander des photos d'inspection tant que l'article est à l'entrepôt. Vous pouvez souvent préciser des angles ou détails, utile pour la coupe, les logos ou les coutures.",
            ],
          },
          {
            h: "Comment lire les photos",
            p: [
              "Comparez les photos à la fiche produit et à votre commande. Cherchez les dommages visibles, les détails incorrects et tout écart. Si quelque chose cloche, signalez-le avant l'expédition.",
            ],
          },
        ],
        tips: [
          {
            t: "Demandez le QC tôt",
            d: "Demandez les photos tant que l'article est à l'entrepôt.",
          },
          {
            t: "Demandez des angles précis",
            d: "Demandez des gros plans des logos ou coutures importants.",
          },
          {
            t: "Comparez à la fiche",
            d: "Vérifiez les photos par rapport à votre commande.",
          },
        ],
        faq: [
          {
            q: "Comment fonctionne le QC AllChinaBuy ?",
            a: "Le QC vous permet de demander des photos d'inspection avant l'envoi pour confirmer la qualité et détecter les problèmes tôt.",
          },
          {
            q: "Puis-je demander des photos QC précises ?",
            a: "Souvent oui — vous pouvez demander des angles précis tant que l'article est à l'entrepôt.",
          },
          {
            q: "Que chercher dans les photos QC ?",
            a: "Les dommages visibles, les détails incorrects et tout écart avec la fiche produit.",
          },
        ],
      },
      "allchinabuy-buying-guide": {
        title: "Guide d'achat AllChinaBuy pour débutants",
        subtitle:
          "Une introduction pas à pas pour les nouveaux acheteurs, du choix d'une catégorie à la finalisation de votre première commande.",
        metaTitle: "Guide d'achat AllChinaBuy pour débutants",
        metaDescription:
          "Nouveau sur AllChinaBuy ? Ce guide débutant couvre le choix d'une catégorie, la comparaison, le QC et la finalisation de votre première commande.",
        metaKeywords:
          "guide débutant AllChinaBuy, AllChinaBuy pour débutants, guide d'achat AllChinaBuy",
        tag: "Guide débutant",
        readTime: "6 min de lecture",
        intro: [
          "Si vous débutez dans l'achat de produits à expédition internationale, le processus peut sembler inhabituel. La bonne nouvelle, c'est qu'il suit un schéma clair une fois les étapes comprises.",
          "Ce guide débutant parcourt une commande AllChinaBuy typique de bout en bout, pour que vous soyez à l'aise avant votre premier achat.",
        ],
        sections: [
          {
            h: "Étape 1 : choisir une catégorie",
            p: [
              "Commencez par une catégorie correspondant à ce que vous voulez — chaussures, hoodies, sacs ou autre. Choisir d'abord une catégorie réduit les choix et simplifie le reste.",
            ],
          },
          {
            h: "Étape 2 : comparer et présélectionner",
            p: [
              "Parcourez les articles et notez ceux qui vous plaisent. Cherchez des fiches avec photos claires, descriptions et infos de contrôle qualité. Une liste courte de deux ou trois options vaut mieux qu'une longue liste.",
            ],
          },
          {
            h: "Étape 3 : vérifier et commander",
            p: [
              "Avant de commander, confirmez les détails importants — taille, options d'expédition et photos QC. Puis finalisez l'achat sur le site principal. Une minute de vérification évite les surprises.",
            ],
          },
        ],
        tips: [
          {
            t: "Allez étape par étape",
            d: "Ne vous précipitez pas — une première commande soignée vous apprend tout.",
          },
          {
            t: "Utilisez le QC dès le début",
            d: "Les photos d'inspection rassurent quand on débute.",
          },
          {
            t: "Commencez par des catégories familières",
            d: "Choisissez des articles que vous savez juger.",
          },
        ],
        faq: [
          {
            q: "Comment passer ma première commande AllChinaBuy ?",
            a: "Choisissez une catégorie, comparez, vérifiez les détails, puis finalisez sur le site principal.",
          },
          {
            q: "Faut-il des outils spéciaux ?",
            a: "Non — il vous faut juste les liens de catégories et un peu d'organisation.",
          },
          {
            q: "AllChinaBuy est-il adapté aux débutants ?",
            a: "Oui, surtout en commençant petit et en utilisant les photos QC.",
          },
        ],
      },
      "allchinabuy-safe": {
        title: "AllChinaBuy est-il sûr ? Guide de confiance et de sécurité",
        subtitle:
          "Un regard pratique sur comment acheter en sécurité — vérification des vendeurs, vigilance sur les paiements, risques produits et expédition.",
        metaTitle: "AllChinaBuy est-il sûr ? Guide de confiance et de sécurité",
        metaDescription:
          "AllChinaBuy est-il sûr ? Un guide pratique pour acheter en sécurité — vérification des vendeurs, paiements, risques produits et expédition expliqués clairement.",
        metaKeywords:
          "AllChinaBuy sûr, sécurité AllChinaBuy, guide sécurité AllChinaBuy",
        tag: "Guide sécurité",
        readTime: "7 min de lecture",
        intro: [
          "La sécurité dépend moins de la plateforme que de votre approche. Tout service d'achat peut être utilisé avec soin ou négligence, et la différence tient à quelques habitudes simples.",
          "Ce guide se concentre sur les étapes pratiques pour acheter en sécurité, sans exagérer ni minimiser les risques.",
        ],
        sections: [
          {
            h: "Vérifiez vendeurs et fiches",
            p: [
              "La première couche de sécurité est votre propre examen. Regardez les infos vendeur, lisez les descriptions et privilégiez les fiches avec photos QC. Les fiches vagues sont un signal pour ralentir et vérifier.",
            ],
          },
          {
            h: "Soyez vigilant sur paiements et politiques",
            p: [
              "Comprenez comment fonctionnent les paiements et lisez les politiques de remboursement et de litige avant de commander. Connaître les règles à l'avance évite de les découvrir sous pression.",
            ],
          },
          {
            h: "Gérez les risques produit et expédition",
            p: [
              "La qualité des produits et l'expédition sont les deux sources de surprises les plus courantes. Utilisez le QC avant l'envoi et vérifiez les options et coûts d'expédition pour votre destination.",
            ],
          },
        ],
        tips: [
          {
            t: "Examinez avant d'acheter",
            d: "Quelques minutes de vérification évitent la plupart des problèmes.",
          },
          {
            t: "Comprenez d'abord les politiques",
            d: "Connaissez les règles avant d'en avoir besoin.",
          },
          {
            t: "Utilisez le QC comme filet",
            d: "Les photos d'inspection détectent les problèmes tant qu'ils sont corrigeables.",
          },
        ],
        faq: [
          {
            q: "AllChinaBuy est-il sûr ?",
            a: "La sécurité dépend de votre usage. Examinez vendeurs, paiements et expédition avant de commander.",
          },
          {
            q: "Quel est le plus grand risque ?",
            a: "La qualité des produits et les frais d'expédition sont les surprises les plus courantes.",
          },
          {
            q: "Comment protéger mon paiement ?",
            a: "Comprenez le processus et lisez les politiques de remboursement et de litige.",
          },
        ],
      },
    },
  },
};